import { httpClient } from '../network/httpclient/HttpClientFactory';

const list = param => httpClient.post('/facemapping-image', param).then(res => res.data);

const detail = id => httpClient.get(`/facemapping/${id}`).then(res => res.data);

const copy = id => httpClient.post(`/copy/${id}`).then(res => res.data);

const saveSiteInfo = param => httpClient.post('/facemapping/siteInfo', param).then(res => res.data);

const saveMobileImageInfo = param => httpClient.post('/facemapping/mobile-image-etc', param).then(res => res.data);

const saveMobileImageTbmInfo = param => httpClient.post('/facemapping/mobil-image-tbm', param).then(res => res.data);

const postComment = param => httpClient.post(`/facemapping/comment`, param).then(res => res.data);

const getCommentList = id => httpClient.get(`/facemapping/comment/${id}`).then(res => res.data);

const deleteComment = id => httpClient.delete(`/facemapping/comment/${id}`).then(res => res.data);

export default {
    list,
    detail,
    copy,
    saveSiteInfo,
    saveMobileImageInfo,
    saveMobileImageTbmInfo,
    postComment,
    getCommentList,
    deleteComment
};
